import axiosApiInstance from "./config/axios-config"
import appSettings from "../appsettings.json"

export const getCustomers = async (permission?: string): Promise<any> => {
    const response = await axiosApiInstance.get(`${appSettings.WebApi.BaseAddress}${appSettings.WebApi.AllCustomersEndpoint}${permission? `?withPermission=${permission}`: ""}`)
    return response.data

}